import { Link, useLocation } from "react-router-dom";
import { useLanguage, LANGS } from "../i18n/LanguageContext";

const BC_MAP = {
    "/experiencia": "experiencia",
    "/equipa": "equipa",
    "/missao": "missao",
    "/contacto": "contacto",
    "/noticias": "noticias",
    "/local": "local",
    "/confirmar": "confirmar",
    "/bilhetes": "bilhetes",
    "/privacidade": "privacidade",
    "/termos": "termos",
    "/recursos": "recursos",
    "/patrocinadores": "patrocinadores",
};

export const SubpageHeader = ({ hideLangs = false }) => {
    const { t } = useLanguage();
    const { pathname } = useLocation();
    const bcKey = BC_MAP[pathname] || (pathname.startsWith("/artistas") ? "artistas" : null);

    return (
        <header className="absolute top-12 left-0 right-0 z-20 px-5 sm:px-10 py-5" data-testid="subpage-header">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
                <Link to="/" data-testid="subpage-logo" aria-label="Voltar à página inicial" className="shrink-0">
                    <img src="/images/logo.webp" alt="Fados à Mesa — 1ª Edição" className="h-9 sm:h-12 w-auto" width="1295" height="388" />
                </Link>
                <div className="flex items-center gap-3 sm:gap-5 shrink-0">
                    {!hideLangs && <SubpageLangs />}
                    <Link
                        to="/"
                        data-testid="subpage-back-button"
                        className="font-caps text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-[#c9a24b] border border-[#c9a24b]/60 px-3 sm:px-6 py-2 sm:py-2.5 hover:bg-[#c9a24b] hover:text-[#070503] transition-colors duration-400"
                    >
                        {t.subpage.voltar}
                    </Link>
                </div>
            </div>
            {bcKey && (
                <nav aria-label="breadcrumb" className="mt-3" data-testid="breadcrumb">
                    <ol className="flex items-center gap-2 font-caps text-[9px] sm:text-[10px] tracking-[0.25em] uppercase">
                        <li>
                            <Link to="/" className="text-[#efe6d6]/50 hover:text-[#c9a24b] transition-colors duration-300">
                                {t.bc.home}
                            </Link>
                        </li>
                        <li aria-hidden="true" className="text-[#c9a24b]/50">/</li>
                        <li aria-current="page" className="text-[#c9a24b]">{t.bc[bcKey]}</li>
                    </ol>
                </nav>
            )}
        </header>
    );
};

const SubpageLangs = () => {
    const { lang, setLang } = useLanguage();
    return (
        <div className="flex items-center gap-2 sm:gap-3" data-testid="subpage-language-switcher">
            {LANGS.map((l) => (
                <button
                    key={l}
                    onClick={() => setLang(l)}
                    aria-pressed={lang === l}
                    data-testid={`subpage-lang-${l}`}
                    className={`font-caps text-[11px] tracking-[0.2em] uppercase transition-colors duration-300 ${
                        lang === l ? "text-[#c9a24b] border-b border-[#c9a24b] pb-0.5" : "text-[#efe6d6]/70 hover:text-[#efe6d6]"
                    }`}
                >
                    {l}
                </button>
            ))}
        </div>
    );
};
